let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7wvde")).then(() => parcelRequire('dXEk5'));